"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIMEOUT = void 0;
var DEFAULT_TIMEOUT = 60000;
exports.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;